import { useState } from 'react';
import useSWR from 'swr';
import { useDebounce } from 'use-debounce';
// api
import getFilteredCarrierUsers from 'modules/emergencies/api/getFilteredCarrierUsers';

// returns selectedFilters and functions to update them
const useCarrierusersFilter = ({ initialQuery = '' }) => {
  const initialSelectedFilters = {
    search: initialQuery,
  };

  const [internalSelectedFilters, setInternalSelectedFilters] = useState(initialSelectedFilters);
  const [selectedFilters] = useDebounce(internalSelectedFilters, 500);

  const filtersKey = JSON.stringify(selectedFilters);
  const { data: carriers, error: carriersError } = useSWR(
    `/carriers/users/${filtersKey}`,
    () => getFilteredCarrierUsers(internalSelectedFilters.search), //change this only allows segments
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingCarriers = typeof carriers === 'undefined' && !carriersError;

  let carrierOptions = [];

  if (carriers) {
    carrierOptions = (carriers?.results || []).map((carrier) => ({
      value: carrier.id,
      label: `${carrier.carrier_stub.name} - ${carrier.first_name}`,
      display: `${carrier.carrier_stub.name} - ${carrier.first_name}`,
      search: `${carrier.carrier_stub.name} - ${carrier.first_name}`,
    }));
  }

  const setSearch = (value) => {
    setInternalSelectedFilters({
      ...internalSelectedFilters,
      search: value,
    });
  };

  return {
    internalSelectedFilters,
    carrierOptions,
    carrierOptionsError: carriersError,
    isLoadingCarrierOptions: isLoadingCarriers,
    setSearch,
  };
};

export default useCarrierusersFilter;
